import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InterrogationElement } from './interrogation.component';
import { createCustomElement } from '@angular/elements';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';

@NgModule({
    declarations: [InterrogationElement],
    imports: [CommonModule, IconModule, TooltipModule],
    exports: [InterrogationElement],
})
export class InterrogationModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(InterrogationElement, {
            injector: this.injector,
        });

        customElements.define('bazis-interrogation', el);
    }
}
